<template>
  <v-container grid-list-md text-xs-center>
    <v-layout v-resize="onResize" :class="{mobile: isMobile}" row wrap>
      <v-flex v-if="!isMobile"  xs12>
        <recharge-header />

        <v-layout v-if="!isMobile" class="justify-center">
          <v-flex xs12 md4>
            <slip-recharge />
          </v-flex>
          <v-flex xs12 md4>
            <anticipation-recharge />
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex v-else>
      <v-layout  class="justify-center">
          <v-flex xs12>
            <slip-recharge />
          </v-flex>
        </v-layout>
        <v-layout style="margin-top: 20px;">
        <v-flex xs12 >
            <anticipation-recharge />
          </v-flex>
        </v-layout>
      </v-flex>

    </v-layout>
  </v-container>
</template>
<script>

export default {
  name: 'RechargeWallet',
  components: {
    RechargeHeader: () => import('@/components/recharge/RechargeHeader.vue'),
    SlipRecharge: () => import('@/components/recharge/SlipRecharge.vue'),
    AnticipationRecharge: () => import('@/components/recharge/AnticipationRecharge.vue'),
  },
  data() {
    return {
      isMobile: false,
    };
  },
  methods: {
    onResize() {
      if (window.innerWidth < 769)
        this.isMobile = true;
      else
        this.isMobile = false;
    },
  },

};
</script>
